import React, {useEffect} from 'react'
import Cookies from 'js-cookie'
import Spinner from 'react-bootstrap/Spinner'

let originLocation = process.env.REACT_APP_REDIRECT_URL

//if (document.referrer === "https://prelive.assetpanda.com/barcode_settings") {
//  originLocation = "https://prelive.assetpanda.com/barcode_settings";
//} else if (
//  document.referrer === "https://refactoring.assetpanda.com/barcode_settings"
//) {
//  originLocation =
//    "https://https://refactoring.assetpanda.com/barcode_settings";
//} else if (
//  document.referrer === "https://stage.assetpanda.com/barcode_settings"
//) {
//  originLocation = "https://stage.assetpanda.com/barcode_settings";
//} else if (
//  document.referrer === "https://production.assetpanda.com/barcode_settings"
//) {
//  originLocation = "https://production.assetpanda.com/barcode_settings";
//} else if (
//  document.referrer === "https://login.assetpanda.com/barcode_settings"
//) {
//  originLocation = "https://login.assetpanda.com/barcode_settings";
//} else {
//  originLocation = "http://localhost:3002/barcode_settings";
//}

export default function SessionCookies(props) {
  const jwtCookie = Cookies.get('pwa_jwt')

  useEffect(() => {
    if (window !== window.parent) {
      window.parent.postMessage('scrollTop', process.env.REACT_APP_BARCODE_WINDOW_URL)
      window.parent.postMessage('extendSession', process.env.REACT_APP_BARCODE_WINDOW_URL)
    } else {
      window.scrollTo(0, 0)
    }
  }, [])

  //TODO set the expiration date on the pwa_jwt
  if (jwtCookie) {
    return props.children
  } else {
    window.top.location.href = originLocation
    return (
      <div className="spinner5">
        <Spinner className="spinner" animation="border" role="status" />
        <br></br>
        <h5>Loading...Please wait</h5>
      </div>
    )
  }
}
